import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.split.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail, fetchCustomerList } from '@/api/PMS/baseInformation/pakinglotoa';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
import { fetchListByType } from '@/api/PMS/dic/dic';
export default {
  props: ['routerIdArr', 'keyValue', 'showDialog'],
  data: function data() {
    return {
      rules: {
        upIdList: [{
          required: true,
          message: '请选择上级机构',
          trigger: 'blur'
        }],
        parkingType: [{
          required: true,
          message: '请选择车位类别',
          trigger: 'blur'
        }],
        parkingCode: [{
          required: true,
          message: '请输入车位号',
          trigger: 'blur'
        }],
        isLease: [{
          required: true,
          message: '请选择租赁控制',
          trigger: 'blur'
        }]
      },
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      childData: {
        upIdList: [],
        customerId: ''
      },
      id: '',
      loading: false,
      isDisabled: false,
      customerList: [],
      typeOption: [],
      rentOption: [],
      options: [],
      cascaderItem: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.id = '';
      this.isDisabled = false;
      this.customerList = [];
      this.typeOption = [];
      this.rentOption = [];
      this.loadParkingType();
      this.loadRentControl();
      this.loadMenuTree();
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
          _this.childData.upIdList = _this.childData.upIdList.join(',').split(',');
          _this.childData.parkingType = _this.childData.parkingType.toString();
          _this.childData.isLease = _this.childData.isLease.toString();
          _this.id = _this.childData.upIdList[_this.childData.upIdList.length - 2];

          _this.getCustomerList();

          delete _this.childData.customerName;
          delete _this.childData.garageName;
          delete _this.childData.isLeaseName;
          delete _this.childData.parkingTypeName;
        });
      } else {
        this.childData = {
          parkingType: '0',
          isLease: '1',
          customerId: ''
        };
        this.childData.upIdList = this.routerIdArr;
        setTimeout(function () {
          _this.getCascaderItem(_this.childData.upIdList, _this.options);
        }, 1000);
      }
    },
    loadMenuTree: function loadMenuTree() {
      var _this2 = this;

      var treeQuery = {
        flag: 3
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this2.options = response.data.data;
        _this2.cascaderItem = [];
        var upIdList = _this2.routerIdArr ? _this2.routerIdArr : [];

        _this2.getCascaderItem(upIdList, _this2.options);

        if (_this2.cascaderItem.length > 0 && _this2.cascaderItem[_this2.cascaderItem.length - 1].flag === '3') {
          _this2.id = _this2.routerIdArr[_this2.routerIdArr.length - 2];

          _this2.getCustomerList();
        }
      });
    },
    loadParkingType: function loadParkingType() {
      var _this3 = this;

      fetchListByType('parking_type').then(function (r) {
        _this3.typeOption = r.data.data;
      });
    },
    loadRentControl: function loadRentControl() {
      var _this4 = this;

      fetchListByType('is_lease').then(function (r) {
        _this4.rentOption = r.data.data;
      });
    },
    getCustomerList: function getCustomerList(query) {
      var _this5 = this;

      query = query || '';
      var queryData = {
        id: this.id,
        name: query
      };
      fetchCustomerList(queryData).then(function (r) {
        _this5.loading = false;
        _this5.customerList = r.data.data;
      });
    },
    // 获取级联选择器的下拉选项的数据
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this6 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this6.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    getNode: function getNode(idList) {
      this.childData.areaGroupId = parseInt(idList[idList.length - 2]);
      this.cascaderItem = [];
      this.getCascaderItem(this.childData.upIdList, this.options);

      if (this.cascaderItem[this.cascaderItem.length - 1].flag !== '3') {
        this.$message({
          message: '上级机构请选择正确的车库',
          type: 'error',
          duration: 3000
        });
        this.id = '';
      } else {
        this.id = idList[idList.length - 2];
        this.isDisabled = false;
        this.childData.customerId = '';
        this.customerList = [];
        this.getCustomerList();
      }
    },
    // checkMenuId() {
    //   if (!this.id) {
    //     this.$message({
    //       message: '请先选择正确的上级机构',
    //       type: 'error',
    //       duration: 5000
    //     })
    //     this.isDisabled = true
    //     return false
    //   }
    // },
    handCreate: function handCreate() {
      var _this7 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this7.childData.garageId = _this7.childData.upIdList[_this7.childData.upIdList.length - 1];

          if (_this7.keyValue > 0) {
            delete _this7.childData.upIdList;
            delete _this7.childData.areaGroupName;
            _this7.childData.isLease = parseInt(_this7.childData.isLease);
            _this7.childData.parkingType = parseInt(_this7.childData.parkingType);
            fetchUpdate(_this7.childData).then(function () {
              _this7.$emit('handCancle', true);

              _this7.Alert({
                alertType: 'update'
              });
            });
          } else {
            if (_this7.cascaderItem[_this7.cascaderItem.length - 1].flag !== '3') {
              _this7.$message({
                message: '上级机构请选择正确的车库',
                type: 'error',
                duration: 3000
              });

              return false;
            }

            delete _this7.childData.upIdList;
            fetchCreate(_this7.childData).then(function () {
              _this7.$emit('handCancle', true);

              _this7.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this7.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'offParkAdd');
    }
  }
};